export default __webpack_public_path__ + "static/media/Earthshock Band.a41bd8b4.jpg";